import React from 'react';

import {
  getWeb3,
} from '../util/web3Helpers';

class WeiToEth extends React.Component {

  state = {
    amount: '...',
  };

  componentWillMount() {
    getWeb3().then(web3 => {
      this.setState({
        amount: web3.utils.fromWei(this.props.amount, 'ether'),
      });
    });
  }

  render() {
    return (
      <span>{this.state.amount}</span>
    );
  }

}

export default WeiToEth;



// WEBPACK FOOTER //
// ./src/components/WeiToEth.js